import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../../../context/Context";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
  TagInput,
} from "../../../../../../component/form/form-layout";
import Style from "./style.module.css";
import LeftSidePopupLayout from "../../../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../../../component/icons/x-close";

const htmlToText = (html = "") => {
  return html
    .replace(/\t/g, "") // remove tabs
    .replace(/\r/g, "") // remove carriage returns
    .replace(/<\/li>/gi, "\n") // li end → newline
    .replace(/<br\s*\/?>/gi, "\n") // br → newline
    .replace(/<[^>]*>/g, "") // remove all other HTML tags
    .replace(/&amp;/g, "&") // decode &amp;
    .replace(/\n\s*\n+/g, "\n") // remove multiple empty lines
    .trim(); // trim start/end
};

const AddSalesPackages = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  productData = null,
  products = [],
  frequency = [],
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const productOptions = products?.map((pr) => ({
    label: pr?.value,
    value: pr?.id,
  }));

  const frequncyOptions = frequency?.map((pr) => ({
    label: pr?.value,
    value: pr?.id,
  }));

  // console.log("productData", productData)

  useEffect(() => {
    if (productData?.id) {
      console.log("package", productData);
      const half_year_discount = productData?.half_year_discount?.replace(
        "%",
        "",
      );
      const annual_discount = productData?.anuual_discount?.replace("%", "");

      formik.setFieldValue("product_id", productData?.product_id);
      formik.setFieldValue("price_key", productData?.price_key);
      formik.setFieldValue("features_html", productData?.features_html);
      formik.setFieldValue("min_price", productData?.min_price);
      formik.setFieldValue("max_price", productData?.max_price);
      formik.setFieldValue("half_year_discount", half_year_discount);
      formik.setFieldValue("anuual_discount", annual_discount);
      formik.setFieldValue("frequency", productData?.frequency);
      formik.setFieldValue("fixed_price", productData?.fixed_price);
      formik.setFieldValue(
        "features",
        productData?.features?.split(",").filter(Boolean),
      );
    }
  }, []);

  const validationSchema = yup.object({
    product_id: yup.number().required("This Field is Required"),
    price_key: yup.string().required("This Field is Required"),
    frequency: yup.string().required("This Field is Required"),
    features_html: yup.string().required("This Field is Required"),
    min_price: yup.number().required("This Field is Required"),
    max_price: yup.number().required("This Field is Required"),
    half_year_discount: yup.number().required("This Field is Required"),
    anuual_discount: yup.number().required("This Field is Required"),
    fixed_price: yup.number().required("This Field is Required"),
    features: yup
      .array("This Field is Required")
      .of(yup.string().trim())
      .min(1, "At least one tag is required")
      .required("At least one tag is required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_id: productData?.product_id ? Number(productData.product_id) : "",
      price_key: productData?.price_key || "",
      features_html: productData?.features_html || "",
      features: "",
      fixed_price: "",
      min_price: "",
      max_price: "",
      frequency: "",
      half_year_discount: "",
      anuual_discount: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        product_id: Number(values.product_id),
        price_key: values.price_key,
        features_html: values.features_html,
        frequency: values?.frequency,
        fixed_price: Number(values.fixed_price),
        min_price: Number(values.min_price),
        max_price: Number(values.max_price),
        half_year_discount: Number(values.half_year_discount),
        anuual_discount: Number(values.anuual_discount),
        features: Array.isArray(values.features)
          ? values.features.join(",")
          : values.features,
      };

      console.log("data ", data);

      try {
        const url = productData?.id
          ? `sales/update-sales-product-price-range/${productData?.id}`
          : "sales/products/add-sales-product-price-range";
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        onSubmit(apiRes?.message || "Add Package successfully");
        formik.resetForm();
        onClose();
      } catch (error) {
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features_html']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features_html]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-5 `}
      >
        <div className="flex flex-col h-full gap-5 w-full overflow-hidden">
          <div
            className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
          >
            <h4>{productData?.id ? "Update" : "Add"} Sales Product</h4>
            <div
              onClick={onClose}
              className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
            >
              <XCloseIcon />
            </div>
          </div>
          {/* Body */}
          <div
            className={`${Style.modal_body} w-full h-full overflow-hidden overflow-y-auto`}
          >
            <FormArea>
              {/*  product */}
              <FeildWraper width="100%">
                <FormLabel required>Product</FormLabel>

                <SelectSearch
                  name="product_id"
                  placeholder={"- Select  Product -"}
                  onChange={(val) => {
                    formik.setFieldValue("product_id", val);
                  }}
                  value={formik.values?.product_id}
                  options={productOptions}
                  onBlur={() =>
                    formik.setFieldTouched("product_id", true, true)
                  }
                  menuPosition="fixed"
                />
                {formik.touched.product_id && formik.errors.product_id && (
                  <FeildError>{formik.errors.product_id}</FeildError>
                )}
              </FeildWraper>

              {/* Frequency */}
              <FeildWraper>
                <FormLabel required>Frequency</FormLabel>

                <SelectSearch
                  name="frequency"
                  placeholder={"- Select  Frequency -"}
                  onChange={(val) => {
                    formik.setFieldValue("frequency", val);
                  }}
                  value={formik.values?.frequency}
                  options={frequncyOptions}
                  onBlur={() => formik.setFieldTouched("frequency", true, true)}
                  menuPosition="fixed"
                />
                {formik.touched.frequency && formik.errors.frequency && (
                  <FeildError>{formik.errors.frequency}</FeildError>
                )}
              </FeildWraper>

              {/*Package name */}

              <FeildWraper
                width={formik.values.main_product == 9 ? `100%` : `50%`}
              >
                <FormLabel required>Price key</FormLabel>
                <input
                  type="text"
                  name="price_key"
                  value={formik.values.price_key}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Price Key"
                />

                {formik.touched.price_key && formik.errors.price_key && (
                  <FeildError>{formik.errors.price_key}</FeildError>
                )}
              </FeildWraper>

              {/* Min Price */}
              <FeildWraper>
                <FormLabel required>Min Price</FormLabel>
                <input
                  type="number"
                  name="min_price"
                  min="0"
                  value={formik.values.min_price}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Min Price"
                />
                {formik.touched.min_price && formik.errors.min_price && (
                  <FeildError>{formik.errors.min_price}</FeildError>
                )}
              </FeildWraper>

              {/* Max Price */}
              <FeildWraper>
                <FormLabel required>Max Price</FormLabel>
                <input
                  type="number"
                  name="max_price"
                  min="0"
                  value={formik.values.max_price}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Max Price"
                />
                {formik.touched.max_price && formik.errors.max_price && (
                  <FeildError>{formik.errors.max_price}</FeildError>
                )}
              </FeildWraper>

              {/* Half year discopunt */}
              <FeildWraper>
                <FormLabel required>Half Year Discount</FormLabel>
                <input
                  type="number"
                  name="half_year_discount"
                  min="0"
                  value={formik.values.half_year_discount}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Half Year Discount"
                />
                {formik.touched.half_year_discount &&
                  formik.errors.half_year_discount && (
                    <FeildError>{formik.errors.half_year_discount}</FeildError>
                  )}
              </FeildWraper>

              {/* anuual_discount*/}
              <FeildWraper>
                <FormLabel required>Annual Discount</FormLabel>
                <input
                  type="number"
                  name="anuual_discount"
                  min="0"
                  value={formik.values.anuual_discount}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Annual Discount"
                />
                {formik.touched.anuual_discount &&
                  formik.errors.anuual_discount && (
                    <FeildError>{formik.errors.anuual_discount}</FeildError>
                  )}
              </FeildWraper>

              {/* Fixed Price */}
              <FeildWraper>
                <FormLabel required>Fixed Price</FormLabel>
                <input
                  type="number"
                  name="fixed_price"
                  min="0"
                  value={formik.values.fixed_price}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  placeholder="Fixed Price"
                />
                {formik.touched.fixed_price && formik.errors.fixed_price && (
                  <FeildError>{formik.errors.fixed_price}</FeildError>
                )}
              </FeildWraper>

              {/* Features */}

              <FeildWraper>
                <FormLabel required>Features</FormLabel>
                <TagInput
                  value={formik.values.features}
                  placeholder="Press enter to create a tag"
                  onChange={(val) => {
                    formik.setFieldTouched("features", true);
                    formik.setFieldValue("features", val, true);
                  }}
                />

                {formik.touched.features && formik.errors.features ? (
                  <FeildError>{formik.errors.features}</FeildError>
                ) : null}
              </FeildWraper>

              {/* Features  html*/}
              <FeildWraper width="100%">
                <FormLabel required>Features</FormLabel>
                <textarea
                  name="features_html"
                  value={formik.values.features_html}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  rows={6}
                  placeholder="Write or edit package features here..."
                />
                {formik.touched.features_html &&
                  formik.errors.features_html && (
                    <FeildError>{formik.errors.features_html}</FeildError>
                  )}
              </FeildWraper>
            </FormArea>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {productData?.id ? "Update" : "Add"} Sales Product
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddSalesPackages;
